<template>
  <div id="selfdeil">
    <h3>设备评审详情</h3>
    <div class="infoDeil">
      <div class="item" @click="rowClick(key, value)" :class="{ margin15: index == 2 || index == 7 || index == 11 }" v-for="(value, key, index) in info" :key="`${key}a`">
        <span class="row2">{{ key }}：</span>
        <span v-if="key != '评审流程状态' && key != '评审类型' && key != '自评结果' && key != '评审证书'">{{ value }}</span>

        <span v-if="key == '评审流程状态'" :class="['orange', 'orange', 'orange', 'red', 'green'][value - 1]">
          {{ ['企业待自评', '专家待分配', '专家评审中', '已截止', '已完成'][value - 1] }}
        </span>
        <span v-if="key == '评审类型'">
          {{ ['日常评审', '年度评审'][value - 1] }}
        </span>
        <span style="cursor: pointer" v-if="key == '自评结果' || key == '评审证书'" class="blue">
          {{ value }}
        </span>
        <div></div>
      </div>
    </div>
    <div class="btnGurop">
      <el-button @click="common.returnBtn"><i class="el-icon-arrow-left"></i></el-button>
      <el-button v-if="info.评审流程状态 == 5" type="primary" @click="rowClick('查看评审报告', '')">查看评审报告</el-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'selfdeil',
  components: {},
  data() {
    return {
      id: this.$route.query.id, // 流程 id
      selfId: this.$route.query.selfId, // 自评 id
      expertId: this.$route.query.expertId,
      info: {},
      inFoINmes: {},
    };
  },
  watch: {},
  created() {
    this.getExaminationInfo();
  },
  mounted() {},
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
  },
  methods: {
    moment,
    // 获取详情回显内容
    getExaminationInfo() {
      this.$axios.post('api/review/info', { expertId: this.expertId, id: this.id }).then((res) => {
        if (res.data.code == 200) {
          const data = res.data.data;
          this.inFoINmes = data;
          this.info = {
            用户名称: data.user.enterprieName,
            目前所涉及的行业: data.user.category,
            自评时间: data.selfAssessmentTime ? moment(data.selfAssessmentTime).format('YYYY-MM-DD') : '--',

            评审流程状态: data.status,
            评审类型: data.type,
            分配时间: data.expertTime ? moment(data.expertTime).format('YYYY-MM-DD') : '--',
            评审模块: data.moduleName || '--',
            评价依据: data.paperName || '--',
            是否主审: ['是', '否'][data.isChiefReviewer - 1] ?? '否',

            评审完成时间: data.expertReviewTime ? moment(data.expertReviewTime).format('YYYY-MM-DD') : '--',
            自评结果: '查看自评结果',
            自评得分: data.selfScore ?? '--',
            专家评审得分: data.appraisalResult || '--',
            设备管理成熟度: data.evaluate ? `${data.evaluate}%` : '--',
            星级: data.starLevel || '--',
          };
          this.getChiefReviewerInfo();
          if (data.status == 5) {
            this.$set(this.info, '评审证书', '查看评审证书');
          }
        }
      });
    },
    // 获取 主评审详情
    getChiefReviewerInfo() {
      this.$axios.post('api/review/chiefReviewerInfo', { selfId: this.selfId }).then((res) => {
        if (res.data.code == 200) {
          this.$set(this.info, '整改意见', res.data.expertOpinion ?? '--');
        }
      });
    },

    rowClick(key, value) {
      switch (key) {
        case '自评结果':
          this.$router.push({
            path: '/initiaSelf',
            query: { id: this.bankId, selfId: this.selfId, isEdit: true },
          });
          break;
        case '评审证书':
          this.$message({
            message: `正在开发中～`,
            type: 'success',
            offset: 80,
          });
          break;
        case '查看评审报告':
          if (this.inFoINmes.expertUsableNumber > 0 || this.inFoINmes.expertUsableNumber == null) {
            window.open(`${this.report}/report.html?selfId=${this.selfId}`, '_blank');
            this.common.reportsNumber(1);
            this.getExaminationInfo();
          } else {
            this.$message({
              message: `使用次数不足，请联系管理员！`,
              type: 'error',
              offset: 80,
            });
          }
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.infoDeil {
  margin: 15px;
  margin-bottom: 60px;
  .item {
    color: rgb(80, 88, 105);
    display: flex;
    line-height: 32px;
    .row2 {
      min-width: 140px;
    }
    &:last-child {
      flex: 1;
    }
  }
}
.margin15 {
  margin-bottom: 25px;
}
.btnGurop {
  position: fixed;
  bottom: 0;
  display: flex;
  background-color: #fff;
  height: 50px;
  align-items: center;
}
</style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
}
</style>
